import React from "react";
import walmart from "../../assets/Rewards/walmart-logo-459 1.png";
import amazon from "../../assets/Rewards/amazon-png-logo-vector-6701 1.png";
import visa from "../../assets/Rewards/Visa New 2021 1.png";
import apple from "../../assets/Rewards/pngwing 4.png";
import best from "../../assets/Rewards/best-buy-png-logo-3002 1.png";
import hotels from "../../assets/Rewards/Hotels.com_Logo_2023 1.png";
import { useTranslation } from "react-i18next";

const logos = [
  { src: walmart, alt: "walmart" },
  { src: amazon, alt: "amazon" },
  { src: visa, alt: "visa" },
  { src: apple, alt: "apple" },
  { src: hotels, alt: "hotels" },
  { src: best, alt: "best" },
];

/* Fade the marquee out at both edges. */
const edgeFade: React.CSSProperties = {
  WebkitMaskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
  maskImage: "linear-gradient(to right, transparent, black 10%, black 90%, transparent)",
};

const LogoRow = ({ hidden = false }: { hidden?: boolean }) => (
  <ul
    className="flex items-center gap-4 pr-4 shrink-0 sm:gap-6 sm:pr-6 animate-infinite-scroll motion-reduce:animate-none"
    aria-hidden={hidden ? "true" : undefined}
  >
    {logos.map((logo) => (
      <li key={logo.alt} className="h-16 px-6 zs-logo-plate w-36 sm:w-44 shrink-0">
        <img src={logo.src} alt={hidden ? "" : logo.alt} className="object-contain w-auto max-w-full max-h-8" />
      </li>
    ))}
  </ul>
);

const RewardCompanies = () => {
  const { t } = useTranslation();
  return (
    <section className="py-12 border-b bg-surface border-line sm:py-16">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <p className="text-center zs-eyebrow">Rewards</p>
        <h2 className="max-w-2xl mx-auto mt-1 text-xl font-semibold leading-snug text-center font-display text-ink-2 sm:text-2xl">
          {t("home.rewardCompanies.thoughts")}{" "}
          <span className="text-primary-text">{t("home.rewardCompanies.getRewards")}</span>
        </h2>
      </div>

      <div className="flex w-full mt-8 overflow-hidden sm:mt-10" style={edgeFade}>
        <LogoRow />
        <LogoRow hidden />
        {/* Third copy keeps the track filled on very wide screens. */}
        <LogoRow hidden />
      </div>
    </section>
  );
};

export default RewardCompanies;
